import PropTypes from 'prop-types';
import React from 'react';
import entityComposition from '../../common/classes/entityComposition';
import valueSelector from '../selectors/valueSelector';
const HeaderBar = _ref => {
  let _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value;
  if (!value) return null; // don't render anything if the value is not set

  const headerStyle = {
    backgroundColor: 'grey',
    color: '#fff',
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
    padding: '10px'
  };
  return /*#__PURE__*/React.createElement("h2", {
    style: headerStyle,
    className: "m-n5 t-hb ".concat(className)
  }, value);
};
HeaderBar.propTypes = {
  className: PropTypes.string,
  format: PropTypes.shape({
    value: PropTypes.string
  }),
  value: PropTypes.string
};
export { HeaderBar as UncomposedHeaderBar };
export default entityComposition(HeaderBar, [], {
  value: valueSelector
});